<template>
  <ModalCard>
    <template #header>
      <div
        class="is-flex is-flex-direction-column is-justify-content-center is-align-items-center is-full-width"
      >
        <div class="my-5">
          <img src="@/assets/logos/logo.svg" :alt="$t('billing.clearestate-logo')" width="120" />
        </div>
        <h2 class="is-size-2 has-text-weight-medium">
          {{ $t('billing.38913047-203a-4e45-b653-44223b229e4d') }}
        </h2>
      </div>
    </template>
    <template #body>
      <section class="p-5">
        <div class="my-5 mx-3">
          <template v-for="(term, termIdx) in purchaseTerms" :key="`term-${termIdx}`">
            <p
              v-for="(paragraph, pIdx) in splitTextParagraphs(term)"
              :key="`term-${termIdx}-p-${pIdx}`"
              class="my-3 has-text-justified"
            >
              {{ paragraph }}
            </p>
          </template>
        </div>
      </section>
    </template>
  </ModalCard>
</template>

<script>
import ModalCard from '/@/modules/core/ui/components/ModalCard.vue';
import { splitTextParagraphs } from '/@/modules/core/app/helpers/StringHelper';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'PurchaseTermsModal',
  components: { ModalCard },
  props: {
    lineItems: {
      type: Array,
      required: true
    }
  },
  computed: {
    purchaseTerms() {
      return this.lineItems.map((lineItem) => lineItem.propertyPurchaseTerm ?? '');
    }
  },
  methods: {
    splitTextParagraphs
  }
};
</script>

<style scoped>
.iframe-container {
  height: calc(100vh - 60px);
}
.purchase-term-section {
  width: 100%;
  height: 100%;
}
</style>
